import { render, staticRenderFns } from "./StripeDashboardRedirect.vue?vue&type=template&id=7079f85a"
import script from "./StripeDashboardRedirect.vue?vue&type=script&lang=js"
export * from "./StripeDashboardRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7079f85a')) {
      api.createRecord('7079f85a', component.options)
    } else {
      api.reload('7079f85a', component.options)
    }
    module.hot.accept("./StripeDashboardRedirect.vue?vue&type=template&id=7079f85a", function () {
      api.rerender('7079f85a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/financial/StripeDashboardRedirect.vue"
export default component.exports